import Component from "../../lib/Component.js";
import { getCurrentUser, openLoginPromptDialog, toggleWatchlist } from "../auth/Auth.js";

export const determineWatchlistButtonState = (button, user) => {
  if (button) button.classList.remove("on-watchlist");
  if (user && user.watchlist.filter((id) => id == button.dataset.movieId).length > 0) {
    if (button) button.classList.add("on-watchlist");
    return true;
  } else {
    return false;
  }
};

/**
 * @param {HTMLElement|null} button
 * @returns {Component}
 */
const WatchlistToggle = (button) => {
  const movieId = button?.dataset.movieId;

  const handleButtonClick = async () => {
    const currentUser = await getCurrentUser();
    if (currentUser) {
      button.classList.add("loading");
      await toggleWatchlist(movieId);
      button.classList.remove("loading");
    } else {
      openLoginPromptDialog(
        "Add a kedvenceidhez!",
        "Lépj be a Mozipremierek regisztrált felhasznlói közé és vedd fel ezt a filmet a kedvenceid listájára!<br>" +
          "<br>" +
          "Kedvenc filmjeidet mindig eléred a profilodból és még a naptáradba is beteheted őket."
      );
    }
  };

  return button
    ? new Component({
        componentName: "WatchlistToggle",
        onMount() {
          button.addEventListener("click", handleButtonClick);
        },
        onUnmount() {
          button.removeEventListener("click", handleButtonClick);
        },
      })
    : Component.noop();
};

export default WatchlistToggle;
